<template lang="pug">
.briq-multilanguage-columns
  .flex(:class="{ 'two-columns': showSecondColumn }")
    .primary.w-full
      slot
    .secondary.w-full(v-show="showSecondColumn")
      slot(name="secondary")
</template>

<script>
import { pipe, concat, map, join, forEach } from 'ramda'

export default {
  name: 'BriqMultilanguageColumns',
  props: {
    translationFields: Array,
    showSecondColumn: Boolean,
    nodesToHide: Array,
  },
  data() {
    return {
      inputs: null,
    }
  },
  mounted() {
    if (!this.translationFields) return
    const inputs = this.$document.querySelectorAll(
      '.briq-multilanguage-columns .secondary .briq-form-element',
    )
    for (const node of inputs) {
      const label = node.querySelector('label')
      if (!this.translationFields.includes(label.textContent.trim())) node.classList.add('hidden')
    }
    if (this.nodesToHide && this.nodesToHide.length) {
      const extraSelector = pipe(
        map(concat('.briq-multilanguage-columns .secondary ')),
        join(', '),
      )(this.nodesToHide)
      forEach(node => node.classList.add('hidden'))(this.$document.querySelectorAll(extraSelector))
    }
  },
}
</script>

<style scoped lang="stylus">
.two-columns
  .primary
    padding-right 10px
    border-right 1px solid #eee

  .secondary
    padding-left 10px
</style>
